// extracted by mini-css-extract-plugin
module.exports = {"card":"PanelsBlock-module--card--1UfsJ","image":"PanelsBlock-module--image--HJzjk"};